import { render, staticRenderFns } from "./ReserveBus.vue?vue&type=template&id=5125a0ff&scoped=true"
import script from "./ReserveBus.vue?vue&type=script&lang=js"
export * from "./ReserveBus.vue?vue&type=script&lang=js"
import style0 from "./ReserveBus.vue?vue&type=style&index=0&id=5125a0ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125a0ff",
  null
  
)

export default component.exports